'use es6';

import React from 'react';
import classnames from 'classnames';
import UIDashboardPage from 'UIComponents/page/UIDashboardPage';
export default (function (props) {
  return React.createElement(UIDashboardPage, Object.assign({}, props, {
    bodyClassName: classnames('dashboard-page', props.bodyClassName)
  }));
});